import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function useAuthGuard() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      navigate('/sign-in', {
        state: { returnUrl: location.pathname },
      });
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname]);

  return { isAuthenticated, isLoading, login };
}
